export enum FilterInterval {
  None = 'None',
  Between = 'Between',
  Outside = 'Outside',
  StartBefore = 'StartBefore',
  StartAfter = 'StartAfter',
  EndBefore = 'EndBefore',
  EndAfter = 'EndAfter',
}

export enum PeriodInterval {
  Today = 'Today',
  Yesterday = 'Yesterday',
  ThisWeek = 'ThisWeek',
  LastWeek = 'LastWeek',
  ThisMonth = 'ThisMonth',
  LastMonth = 'LastMonth',
  ThisYear = 'ThisYear',
  LastYear = 'LastYear',
  Custom = 'Custom',
}

export enum IntervalItemsVisibility {
  None = 'None',
  From = 'From',
  FromTo = 'FromTo',
}

export const excludedRequestValues = [
  'DepartmentDescription',
  'UserDescription',
  'label',
  'UserNameDescription',
  'StartDay',
  'EndDay',
];
